import { Link as MuiLink, Divider } from '@material-ui/core'
import getConfig from 'next/config'
import theme from '../common/theme'

const { publicRuntimeConfig } = getConfig()

const getFaqInter = (lang) => {
    const trans = (contentTh, contentEn) => {
        if (lang === 'en') return contentEn
        return contentTh
    }

    const faqQuestionStyle = {
        color: theme.palette.primary.main,
    }

    return {
        [trans('ข้อมูลทั่วไป', 'SHIPPOP Cross Border')]: {
            [trans('เกี่ยวกับบริการของเรา', 'SHIPPOP Cross Border Service')]: trans(
                <>
                    <p>
                        <strong>SHIPPOP Cross Border</strong> เป็นบริการจองขนส่งพัสดุไปต่างประเทศแบบออนไลน์เพื่อให้ท่านสามารถใช้บริการขนส่งได้อย่าง สะดวกและรวดเร็ว
                        สามารถเปรียบเทียบราคาค่าจัดส่งสินค้าจากบริษัทขนส่งที่คุณต้องการ  ชําระเงินออนไลน์ได้หลายช่องทาง ออกหมายเลขพัสดุและพิมพ์ใบปะหน้า
                        พัสดุได้จากระบบทันที รวมถึงการติดตามสถานะพัสดุได้ผ่านระบบ SHIPPOP Tracking นอกจากนี้ยังมีบริการรับของถึงบ้าน เพียงสร้างพัสดุและเลือกวันที่เข้ารับ
                    </p>
                    <ul>
                        <li>สะดวกรวดเร็ว</li>
                        <li>เปรียบเทียบราคาหลายขนส่ง</li>
                        <li>ชำระเงินได้หลายช่องทาง</li>
                        <li>พิมพ์ใบปะหน้าได้ทันที</li>
                        <li>ระบบติดตามพัสดุ</li>
                    </ul>
                </>,
                <>
                    <p>
                        <strong>SHIPPOP Cross Border</strong> is an online international parcel booking service that allows you to use the shipping service efficiently, convenient and fast.
                        You can compare shipping prices from your preferred shipping company. Online payment through many channels, issue the parcel number and print the airway bills immediately.
                        Including parcel tracking through the SHIPPOP Tracking system. There is also a pickup service by create a parcel and choose a pickup date.
                    </p>
                    <ul>
                        <li>Convenient and fast</li>
                        <li>Compare multiple shipping company prices</li>
                        <li>Multiple payment methods</li>
                        <li>Immediately print the airway bills</li>
                        <li>Parcel tracking system</li>
                    </ul>
                </>
            )
        },
        [trans('ขั้นตอนการส่ง', 'Steps for Create Shipment')]: {
            [trans('ขั้นตอนการส่งและใช้บริการ SHIPPOP Pick Up Service', 'Procedures for sending and using the SHIPPOP Pick Up Service')]: trans(
                <>
                    <ol>
                        <li>เช็คราคาบนหน้าเว็บไซต์</li>
                        <li>สร้างพัสดุ</li>
                        <li>รอการเข้ารับพัสดุ</li>
                    </ol>
                </>,
                <>
                    <ol>
                        <li>Check the price on the website</li>
                        <li>Create a shipment</li>
                        <li>Wait for parcel pickup</li>
                    </ol>
                </>
            ),
            [trans('ขั้นตอนการจัดส่งพัสดุด้วยตัวเองที่จุด Drop Off', 'Procedure for delivering parcels by yourself at the Drop Off point')]: trans(
                <>
                    <ol>
                        <li>เช็คราคาบนหน้าเว็บไซต์</li>
                        <li>สร้างพัสดุ</li>
                        <li>นำพัสดุส่งที่จุด Drop Off</li>
                    </ol>
                    <p>( <MuiLink href="https://www.shippop.com/nearby-dropoff">ค้นหาสาขาจุดบริการส่งพัสดุ</MuiLink> )</p>
                </>,
                <>
                    <ol>
                        <li>Check the price on the website.</li>
                        <li>Create a shipment</li>
                        <li>Bring parcel to drop off point</li>
                    </ol>
                    <p>( <MuiLink href="https://www.shippop.com/nearby-dropoff">Find drop off point</MuiLink> )</p>
                </>
            )
        },
        [trans('เกี่ยวกับราคา', 'About Pricing')]: {
            [trans('เกณฑ์การคํานวณราคาค่าขนส่ง', 'Criteria for calculating the price of shipping')]: trans(
                <>
                    <ul>
                        <li>ประเภทการจัดส่ง</li>
                        <li>น้ำหนักและขนาดพัสดุ</li>
                        <li>บริษัทขนส่ง</li>
                        <li>ประเทศปลายทาง</li>
                    </ul>
                </>,
                <>
                    <ul>
                        <li>Type of service</li>
                        <li>Weight and size</li>
                        <li>Shipping company</li>
                        <li>Destination country</li>
                    </ul>
                </>
            ),
            [trans('วิธีการคำนวณส่งของ/น้ำหนักและเงื่อนไขการจัดส่งของแต่ละขนส่ง', 'How to calculate weight and conditions of each courier')]:
                <>
                    <img
                        src={`/static/img/faq/cross_border_package_sizing_${lang === 'en' ? 'en' : 'th'
                            }.png`}
                        alt="How to calculate weight and conditions of each courier"
                        style={{ maxWidth: 550 }}
                    />
                    {trans(
                        <div>
                            <p>Aramex (Priority - Document)  แต่ละด้านต้องไม่เกิน 100 เซนติเมตรต่อหนึ่งด้าน และน้ำหนักไม่เกิน 30 กิโลกรัมต่อกล่อง</p>
                            <p>Aramex (Priority - Parcel) เป็นซองเอกสาร น้ำหนักไม่เกิน 2 กิโลกรัมต่อซอง</p>
                            <p>Ems World - Document ส่งแบบด่วน (เอกสาร): เอกสาร น้ำหนักไม่เกิน 5 Kg</p>
                            <p>Ems World - Package ส่งแบบด่วน (พัสดุ): พัสดุทั่วไป น้ำหนักไม่เกิน 30 Kg</p>
                            <p>Thai Post (ePacket) ส่งแบบธรรมดา: พัสดุทั่วไป น้ำหนักไม่เกิน 2 Kg ยกเว้น ประเทศอังกฤษไม่เกิน 5 kg</p>
                        </div>,
                        <div>
                            <p>Aramex (Priority - Parcel) each side must not exceed 100 cm per side and weight not exceeding 30 kg per box</p>
                            <p>Aramex (Priority - Document) is a document envelope. Weight not exceeding 2 kg per pack</p>
                            <p>Ems World - Document Express delivery (Documents): Documents weight not exceeding 5 Kg</p>
                            <p>Ems World - Package Express delivery (parcel): general parcel, not exceeding 30 kg</p>
                            <p>Thai Post (ePacket) Normal Delivery: general parcels weight not exceeding 2 Kg except for the UK, not exceeding 5 Kg</p>
                        </div>
                    )}
                </>

        },
        [trans('สินค้าต้องห้าม', 'Prohibited Items')]: {
            [trans('สินค้าต้องห้าม', 'Prohibited Items')]:
                <>
                    {trans(
                        <div>
                            <strong>สินค้าต้องห้ามในการขนส่งทางอากาศมีดังนี้</strong>
                            <ul>
                                <li>ห้ามวัตถุลามกอนาจาร</li>
                                <li>ห้ามสัตว์ ที่มีชีวิตต่างๆ รวมถึงปลาและนก</li>
                                <li>ห้ามเงินสดและสิ่งต่างๆ ที่สามารถทดแทนเงินสดได้ เช่น เช็ค ธนบัตร หรือตราสารหนี้</li>
                                <li>ห้ามอาวุธปืนที่ประกอบเป็นชิ้นสมบูรณ์แล้ว รวมถึงกระสุน และอาวุธทุกชนิดและส่วนประกอบต่างๆของอาวุธยุทธภัณฑ์ วัตถุระเบิด – อาวุธปืนทั้งจริงและเลียนแบบ</li>
                                <li>ห้ามยา และสิ่งเสพติดผิดกฎหมาย</li>
                                <li>สิ่งที่เป็นอันตรายทางชีวภาพ เชื้อโรค เชื้อแบคทีเรีย เชื้อไวรัส สารกัมมันตภาพรังสี สารพิษ</li>
                                <li>ห้ามสารเคมีทุกชนิด สินค้าอันตราย วัตถุอันตราย</li>
                                <li>ห้ามสินค้าละเมิด ลิขสิทธิ์ สินค้าปลอมหรือลอกเลียนแบบเครื่องหมายการค้า</li>
                                <li>ห้ามสิ่งของต้องห้ามในการขนส่งทางอากาศ สินค้าที่เป็นถ่านหรือแบตเตอรี่ทุกชนิด</li>
                                <li>ห้ามวัตถุมีคมที่ปราศจากสิ่งห่อหุ้ม</li>
                                <li>ห้ามสินค้าที่มีส่วนผสมของแอลกอฮอล์</li>
                                <li>ห้าม พืชพันธุ์ เมล็ดพันธุ์พืช ไม้ต้องห้ามบางประเภท</li>
                                <li>ห้ามสมุนไพรที่ขึ้นทะเบียนเป็นยา</li>
                                <li>สลากกินแบ่ง, ลอตเตอรี่ หรือสื่อการพนันต่างๆ</li>
                                <li>ห้ามเอกสารนิติกรรมเฉพาะผู้ถือที่ตกลงกัน</li>
                                <li>ห้ามโลหะหรือหินอันมีค่า</li>
                                <li>ห้ามอาหารสด อาหารที่มีน้ำประกอบ อาหารที่ต้องควบคุมอุณหภูมิ</li>
                                <li>ห้ามเครื่องเพชร พลอย อัญมณี หรือสิ่งของที่มีมูลค่าสูงต่างๆ</li>
                                <li>ห้ามองค์พระ พระเครื่อง เทวรูป และวัตถุโบราณต่างๆ</li>
                                <li>ห้ามทองคำ แท่งหรือเงินแท่ง</li>
                                <li>ห้ามภาษีอากรแสตมป์ ต่างๆ รวมถึง ป้ายตราภาษีอากร</li>
                                <li>ห้ามชิ้นส่วนมนุษย์ รวมถึงเถ้าอัฐิ</li>
                                <li>ห้ามผลิตภัณฑ์จากสัตว์ที่ไม่มีใบอนุญาต (ในบางประเทศ)</li>
                                <li>ห้ามกระเป๋าเดินทาง (ที่ไม่ได้บรรจุในกล่องพัสดุ) ห้ามล็อค หรือใส่รหัสล็อค</li>
                            </ul>
                        </div>,
                        <div>
                            <strong>Prohibited goods for air freight are as follows</strong>
                            <ul>
                                <li>Prohibition of obscene material </li>
                                <li>No living animals are allowed including fish and birds</li>
                                <li>Prohibited cash and stuff that can replace cash, such as checks, banknotes or debt instruments</li>
                                <li>Completely assembled firearms are prohibited, including ammunition and all types of weapons and their components, explosives - real and imitation firearms</li>
                                <li>Prohibition of drugs and illegal drugs</li>
                                <li>Biological hazards, pathogens, bacteria, viruses, radioactive substances, toxins</li>
                                <li>No chemicals of any kind are allowed</li>
                                <li>Prohibit pirated products, counterfeit products or imitate trademarks</li>
                                <li>Products that are batteries or batteries of all kinds</li>
                                <li>Do not use sharp objects without a shield</li>
                                <li>Products that contain alcohol are prohibited</li>
                                <li>Prohibited plants, seeds</li>
                                <li>Do not use herbs that are registered as medicines</li>
                                <li>Lottery tickets, lotteries or various gambling media</li>
                                <li>Prohibiting legal documents only for the holders who have made an agreement</li>
                                <li>Precious metals or stones </li>
                                <li>Fresh food, food containing water or temperature controlled food</li>
                                <li>Jewelry, gems, gems or items of high value</li>
                                <li>Buddha images, amulets, idols and ancient objects</li>
                                <li>Gold bars or silver bars</li>
                                <li>Stamp including tax stamps</li>
                                <li>Human parts including ashes</li>
                                <li>Unlicensed animal products (in some countries)</li>
                                <li>Luggage (Not in the package) and do not lock or enter the lock code</li>
                            </ul>
                        </div>
                    )}
                    <img
                        src="/static/img/faq/restricted_items_list.png"
                        alt="Prohibited Items"
                        style={{ maxWidth: 750 }}
                    />
                </>
        },
        [trans('สินค้าต้องกำกัด', 'Restricted Products')]: {
            [trans('สินค้าต้องกำกัด', 'Restricted Products')]: 'Restricted products'
        },
        [trans('คู่มือการบรรจุพัสดุ', 'Packing guide')]: {
            [trans('การบรรจุแบบกล่อง', 'Box packing')]:
                <>
                    {trans(
                        <ul>
                            <li>สามารถใช้บรรจุภัณฑ์ของตัวเองได้ หากกล่องนั้นแข็งแรงและไม่เสียหายหากถูกกระแทก</li>
                            <li>สินค้าแต่ละชิ้น จะต้องห่อหุ้มด้วยวัสดุกันกระแทก</li>
                            <li>สําหรับสินค้าที่มีรูปร่างไม่ปกติ ควรทําการห่อ  และปิดปกคลุมด้านที่เป็นของแหลมหรือส่วนที่ยื่นออกมาทั้งหมด</li>
                            <li>ติดเทปปิดผนึกทุกรอยต่อให้เรียบร้อยทั้งด้านบนและด้านล่างของกล่องพัสดุ โดยใช้วิธีติดเทปแบบตัว H</li>
                            <li>ติดที่อยู่และฉลากบนกล่องพัสดุของคุณ</li>
                        </ul>,
                        <ul>
                            <li>Use their own packaging if the box is strong and not damaged if knocked</li>
                            <li>Each item must be wrapped in cushioning material</li>
                            <li>For irregular shaped items, wrap and cover all pointed or protruding parts</li>
                            <li>Attach tape to seal every seam neatly on both the top and bottom of the package by using the method of attaching the H-shaped tape</li>
                            <li>Stick the address and label on your package</li>
                        </ul>
                    )}
                    <img
                        src="/static/img/faq/package_example_1.png"
                        alt="Box acking"
                        style={{ maxWidth: 550 }}
                    />
                </>,
            [trans('การบรรจุแบบซอง', 'Sachet packing')]: trans(
                <ul>
                    <li>ทําการห่อสินค้าด้วยวัสดุกันกระแทกก่อนบรรจุลงซอง</li>
                    <li>ปิดปากถุงด้วยเทปกาวที่ปากซอง และพับปิดตามรอยปากถุง</li>
                    <li>หลีกเลี่ยงการพับปิดปากถุงตามขนาดสินค้า เนื่องจากทําให้มีเนื้อที่สําหรับติดฉลากชื่อที่อยู่ไม่เพียงพอ</li>
                </ul>,
                <ul>
                    <li>Wrap the product with cushioning material before packing it into the envelope</li>
                    <li>Seal the mouth of the bag with adhesive tape at the mouth of the envelope and folded closed along the mouth of the bag</li>
                    <li>Avoid folding the mouth of the bag according to the size of the product. Because there is not enough space for the name and address label</li>
                </ul>
            )
        },
        [trans('เกี่ยวกับขนส่งและเอกสารที่ต้องใช้', 'About Courier And Required Documents')]: {
            [trans('เอกสารที่ต้องใช้', 'Documents required ')]:
                <>
                    {trans(
                        <div>
                            <ul>
                                <li>ใบนำส่งสินค้า (Air Waybill)</li>
                                <li>
                                    ใบกำกับสินค้า (Commercial Invoice)
                                    <div>
                                        ( สามารถดาวน์โหลดใบกำกับสินค้า (Commercial Invoice) <MuiLink href="https://www.shippop.com/static/files/faq/INV-template-en-12.docx">ได้ที่นี่</MuiLink> )
                                    </div>
                                </li>
                                <li>สำเนาบัตรประชาชน (แล้วแต่ขนส่ง)</li>
                            </ul>
                            <p>
                                ผู้จัดส่งจะต้องกรอกใบนําส่ง (Air Waybill) และใบกำกับสินค้า (Commercial Invoice) เป็นภาษาอังกฤษทั้งหมด โดยแนบใบนําส่งสินค้า (Air Waybill)
                                ที่สมบูรณ์ติดที่พัสดุทุกชิ้นเสมอ ทั้งนี้พัสดุของคุณอาจต้องมีเอกสารเกี่ยวกับพิธีการศุลกากรแนบมาด้วย เช่น ใบกํากับสินค้า (Commercial Invoice)
                                หรือเอกสารจําเป็นเพิ่มเติมอื่นๆขึ้นอยู่กับปริมาณและมูลค่าของสินค้า รวมถึงระเบียบข้อบังคับของประเทศปลายทางนั้นๆ ที่พัสดุถูกขนส่งไป
                            </p>
                        </div>,
                        <div>
                            <ul>
                                <li>Air Waybills</li>
                                <li>
                                    Commercial Invoice
                                    <div>
                                        ( You can download Commercial Invoice <MuiLink href="https://www.shippop.com/static/files/faq/INV-template-en-12.docx">here</MuiLink> )
                                    </div>
                                </li>
                                <li>Copy of identification card (depending on shipping company)</li>
                            </ul>
                            <p>
                                Shippers are required to complete all Air Waybills and Commercial Invoices in english by attaching the Air Waybill
                                that is always attached to every piece of parcel. Your package may also be accompanied by customs clearance documents, such as a commercial invoice
                                or other additional required documents depending on the quantity and value of the goods Including the regulations of that destination country where the parcel is shipped.
                            </p>
                        </div>
                    )}
                    <table style={{ textAlign: 'center' }}>
                        <thead>
                            <tr>
                                <th>Service</th>
                                <th>Airway Bills</th>
                                <th>Commercial Invoice</th>
                                <th>Copy of Identification Card</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ textAlign: 'left' }}>Aramex - Priority (Document)</td>
                                <td style={{ width: '20%' }}>3</td>
                                <td style={{ width: '20%' }}>-</td>
                                <td style={{ width: '20%' }}>-</td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: 'left' }}>Aramex - Priority (Parcel)</td>
                                <td style={{ width: '20%' }}>3</td>
                                <td style={{ width: '20%' }}>3</td>
                                <td style={{ width: '20%' }}>1</td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: 'left' }}>Thaipost - Ems World (Document)</td>
                                <td style={{ width: '20%' }}>4</td>
                                <td style={{ width: '20%' }}>-</td>
                                <td style={{ width: '20%' }}>-</td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: 'left' }}>Thaipost - Ems World (Package)</td>
                                <td style={{ width: '20%' }}>4</td>
                                <td style={{ width: '20%' }}>-</td>
                                <td style={{ width: '20%' }}>-</td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: 'left' }}>Thaipost - Epackage</td>
                                <td style={{ width: '20%' }}>1</td>
                                <td style={{ width: '20%' }}>-</td>
                                <td style={{ width: '20%' }}>-</td>
                            </tr>
                        </tbody>
                    </table>
                </>,
            [trans('ระยะเวลาในการจัดส่ง', 'Delivery time')]:
                <>
                    {
                        trans(
                            <div>
                                <p>Aramex (Priority - Document) 3 - 9 วันทำการ</p>
                                <p>Aramex (Priority - Parcel) 8 - 11 วันทำการ</p>
                                <p>Ems World - Document 2 - 9 วันทำการ</p>
                                <p>Ems World - Package 2 - 9 วันทำการ</p>
                                <p>Thai Post (ePacket) 3 - 24 วันทำการ </p>

                            </div>,
                            <div>
                                <p>Aramex (Priority - Document) 3 - 9 business days</p>
                                <p>Aramex (Priority - Parcel) 8 - 11 business days</p>
                                <p>Ems World - Document 2 - 9 business days</p>
                                <p>Ems World - Package 2 - 9 working days</p>
                                <p>Thai Post (ePacket) 3 - 24 business days</p>
                            </div>
                        )
                    }
                    <img
                        src="/static/img/faq/transfer-duration.png"
                        alt="Delivery time"
                        style={{ maxWidth: 750 }}
                    />
                    {
                        trans(
                            <p>(ระยะเวลาการทำการอาจเพิ่ม 7 วันทำการ หรือมากกว่าในบางประเทศ เนื่องจากสถานการณ์ Covid-19)</p>,
                            <p>(Working period may increase 7 business days or more in some countries due to the Covid-19 situation)</p>
                        )
                    }
                </>,
            [trans('เงื่อนไขแต่ละขนส่ง', 'Conditions of couriers')]:
                <>
                    <ul>
                        <li>
                            <MuiLink
                                href="/static/files/faq/conditions_aramex_2.pdf"
                                target="_blank"
                            >
                                {trans('PDF เงื่อนไข Aramex', 'PDF Conditions of Aramex')}
                            </MuiLink>
                        </li>
                        <li>
                            <MuiLink
                                href="/static/files/faq/conditions_thaipost_2.pdf"
                                target="_blank"
                            >
                                {trans('PDF เงื่อนไข ไปรษณีย์ไทย', 'PDF Conditions of Thaipost')}
                            </MuiLink>
                        </li>
                    </ul>
                </>
        },
        [trans('กรณีพัสดุติดปัญหา', 'In the event that the parcel has a problem')]: {
            [trans('กรณีพัสดุเสียหาย', 'Damage parcel')]: trans(
                <p>
                    ผู้รับสินค้าต้องทําการติดต่อ Shipping Agent (ปลายทาง) หรือ SHIPPOP ภายใน 7 วันหลังจากวันที่สินค้าไปถึงปลายทางเรียบร้อยแล้ว
                    และพบว่าสินค้าเกิดความเสียหาย โดยให้ทําการถ่ายรูปพัสดุที่เกิดความเสียหาย ใบกํากับสินค้า (Commercial Invoice) และใบนําส่งสินค้า (Air Waybill)
                    ส่งมาทาง Email : cs@shippop.com หรือ <MuiLink href="https://line.me/R/ti/p/@shippop" target='_blank'>Line OA</MuiLink>
                </p>,
                <p>
                    The consignee must contact the shipping Agent (destination) or SHIPPOP within 7 days after the date the product has reached its destination
                    and found that the product was damaged by taking pictures of damaged parcels, commercial invoice and air waybills.
                    Send to Email : cs@shippop.com or <MuiLink href="https://line.me/R/ti/p/@shippop" target='_blank'>Line OA</MuiLink>
                </p>
            ),
            [trans('กรณีพัสดุสูญหาย', 'Lost parcel')]: trans(
                <>
                    <p>กรณีพัสดุสูญหาย ทาง SHIPPOP จะรับประกันและชดใช้ค่าเสียหายเบื้องต้นตามมูลค่าสินค้าที่ลูกค้าระบุในวงเงินตามแต่ ละขนส่งดังนี้</p>
                    <ul>
                        <li>Aramex (Priority - Document) สูงสุดไม่เกิน 3,000 บาท</li>
                        <li>Aramex (Priority - Parcel) สูงสุดไม่เกิน 3,000 บาท</li>
                        <li>Ems World - Document สูงสุดไม่เกิน 3,000 บาท</li>
                        <li>Ems World - Package สูงสุดไม่เกิน 7,000 บาท</li>
                        <li>Thai Post (ePacket) ไม่มีการชดใช้ค่าเสียหายทุกกรณี</li>
                    </ul>
                </>,
                <>
                    <p>In the event that the parcel is lost, SHIPPOP will guarantee and compensate the initial damages according to the product value specified by the customer in the amount according to each and transportation as follows</p>
                    <ul>
                        <li>Aramex (Priority - Document) up to 3,000 baht</li>
                        <li>Aramex (Priority - Parcel) up to 3,000 baht</li>
                        <li>Ems World - Document up to 3,000 baht</li>
                        <li>Ems World - Package up to 7,000 baht</li>
                        <li>Thai Post (ePacket) does not indemnify for any damages</li>
                    </ul>
                </>
            ),
            [trans('กรณีพัสดุถูกตีกลับ', 'Reject parcel')]: trans(
                <p>
                    Shipping Agent (ปลายทาง) จะติดต่อกลับเพื่อยืนยันการดำเนินการส่งสินค้ากลับ ผ่านช่องทางโทรศัพท์ SMS หรือ Email
                    ที่ท่านได้เลือกไว้เบื้องต้น โดยค่าใช้จ่ายในการส่งสินค้ากลับจะขึ้นอยู่กับประเทศปลายทางที่ได้ทำการส่งสินค้าไป
                </p>,
                <p>
                    The Shipping Agent (Destination) will contact you to confirm the return shipping process via telephone, SMS or Email
                    that you have initially selected. The cost of sending the item back depends on the country of destination the item was sent to.
                </p>
            )
        },
        [trans('เกี่ยวกับการชำระเงิน', 'About Payment')]: {
            [trans('วิธีการตรวจสอบใบแจ้งหนี้', 'How to check invoice')]: trans(
                <>
                    <p>
                        ลูกค้าสามารถตรวจสอบใบแจ้งหนี้ได้ภายในทุกวันศุกร์ของอาทิตย์ที่ลูกค้าทำรายการ
                        โดยท่านจะได้รับเครดิต 7 วันหลังจากที่ระบบได้ออกใบแจ้งหนี้
                    </p>
                    <p>* ในกรณีที่ลูกค้าผิดนัดชำระ ทางบริษัทจะคิดเบี้ยปรับผิดนัดชำระร้อยละ 12 ต่อปี</p>
                </>,
                <>
                    <p>
                        Customers can check their invoices by every Friday of the week that customers make transactions.
                        You will be credited 7 days after the system has issued the invoice.
                    </p>
                    <p>* In the event that the customer defaults on payment. The company will charge a late payment penalty of 12 percent per year.</p>
                </>
            ),
            [trans('วิธีชำระเงิน', 'Payment method')]: trans(
                <>
                    <ol>
                        <li>ชำระเงินโดยการโอนเงินเท่านั้น ชำระเงินมาที่บริษัท ชิปป๊อป จำกัด ธนาคาร กสิกรไทย สาขา เอ็มไพร์ ทาวเวอร์ เลขที่บัญชี 007-8-24466-6</li>
                        <li>ท่านจะได้รับเครดิต 7 วันหลังจากที่ระบบออกใบแจ้งหนี้ โดยท่านสามารถตรวจสอบใบแจ้งหนี้ได้ภายในวันศุกร์ของอาทิตย์ที่ท่านทำรายการ</li>
                    </ol>
                    <p>* ในกรณีที่ลูกค้าผิดนัดชำระ ทางบริษัทจะคิดเบี้ยปรับผิดนัดชำระร้อยละ 12 ต่อปี</p>
                </>,
                <>
                    <ol>
                        <li>Payment by bank transfer only. Pay to Chippop Company Limited, Kasikorn Bank, Empire Tower Branch, account number 007-8-24466-6</li>
                        <li>You will be credited 7 days after the system is invoiced. You can check the invoice within the Friday of the week you made the transaction.</li>
                    </ol>
                    <p>* In the event that the customer defaults on payment. The company will charge a late payment penalty of 12 percent per year.</p>
                </>
            ),
            [trans('ช่องทางการแจ้งชำระเงิน', 'Chanels for inform payment')]: trans(
                <>
                    <p>แจ้งการชำระเงินผ่านทาง อีเมล bill@shippop.com โดยมีขอรายละเอียดดังนี้</p>
                    <ol>
                        <li>หมายเลขใบแจ้งหนี้ (Invoice No)</li>
                        <li>ยอดเงินและวันที่โอน</li>
                        <li>หลักฐานการชำระเงิน</li>
                    </ol>
                    <p>
                        หลังจากที่มีการแจ้งชำระเงินเรียบร้อยแล้ว จะดำเนินการออกใบเสร็จรับเงินให้ภายในวันทำการวันถัดไป
                        โดยสามารถตรวจสอบใบเสร็จรับเงินได้ที่เมนู “รายงาน &#62; ใบเสร็จรับเงิน"
                    </p>
                    <p>กรณีลูกค้านิติบุคคล หักภาษี ณ ที่จ่าย จะต้องทำการส่งเอกสารฉบับจริงมาตามที่อยู่บริษัท เพื่อดำเนินการออกใบเสร็จรับเงินให้ต่อไป</p>
                    <p style={{ textDecoration: 'underline' }}><strong>ที่อยู่</strong></p>
                    <p style={{ margin: 0 }}>บริษัท ชิปป๊อป จำกัด (สำนักงานใหญ่)</p>
                    <p style={{ margin: 0 }}>เลขที่ 34 อาคารซี.พี.ทาวเวอร์ 3 ห้องเลขที่ A04-402 ชั้นที่ 4</p>
                    <p style={{ margin: 0 }}>ถนนพญาไท แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400</p>
                    <p style={{ margin: 0 }}>โทร. (+66) 2-096-6629</p>
                </>,
                <>
                    <p>Payment notification via email bill@shippop.com with the following details:</p>
                    <ol>
                        <li>Invoice No</li>
                        <li>Amount and transfer date</li>
                        <li>Proof of Payment</li>
                    </ol>
                    <p>
                        after the notification of payment has been completed A receipt will be issued within the next business day.
                        You can check the receipts at the menu "Report &#62; Receipts"
                    </p>
                    <p>In the case of corporate customers deducting withholding tax, the original documents must be sent to the company address to continue issuing receipts</p>
                    <p style={{ textDecoration: 'underline' }}><strong>Address</strong></p>
                    <p style={{ margin: 0 }}>Shippop Company Limited (Head Office)</p>
                    <p style={{ margin: 0 }}>No.34 C.P.Tower 3 Building, Room No. A04-402, 4th Floor</p>
                    <p style={{ margin: 0 }}>Phayathai road, Thung Phayathai Sub-district, Ratchathewi District, Bangkok 10400</p>
                </>
            ),
            [trans('การรับใบเสร็จรับเงิน', 'Getting a receipt')]: trans(
                <>
                    <p>
                        ใบเสร็จจะออกให้ในวันทำการวันถัดไปหลังจากได้รับการแจ้งชำระเงินและหลักฐานการชำระเงินครบถ้วน
                        หากต้องการใบเสร็จฉบับจริง จะมีการดำเนินการส่งให้ตามที่อยู่จัดส่งเอกสารที่มีในระบบ (เฉพาะลูกค้ารายสัปดาห์เท่านั้น) โดยจะรวบรวมส่งเดือนละหนึ่งครั้ง
                        หลังสิ้นเดือน 1 อาทิตย์
                    </p>
                    <p>กรณีลูกค้านิติบุคคล หักภาษี ณ ที่จ่าย จะต้องทำการส่งเอกสารฉบับจริงมาตามที่อยู่บริษัทดังนี้ เพื่อดำเนินการออกใบเสร็จรับเงินให้ต่อไป</p>
                    <p style={{ textDecoration: 'underline' }}><strong>ที่อยู่</strong></p>
                    <p style={{ margin: 0 }}>บริษัท ชิปป๊อป จำกัด (สำนักงานใหญ่)</p>
                    <p style={{ margin: 0 }}>เลขที่ 34 อาคารซี.พี.ทาวเวอร์ 3 ห้องเลขที่ A04-402 ชั้นที่ 4</p>
                    <p style={{ margin: 0 }}>ถนนพญาไท แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400</p>
                    <p style={{ margin: 0 }}>โทร. (+66) 2-096-6629</p>
                </>,
                <>
                    <p>
                        A receipt will be issued on the next working day after payment notification and proof of payment are complete.
                        If you want the original receipt, delivery will be made to the document delivery address available in the system (for weekly customers only) will be collected once a month
                        after the end of the month 1 week
                    </p>
                    <p>In the case of corporate customers deducting withholding tax, the original documents must be sent to the company address as follows to continue issuing receipts</p>
                    <p style={{ textDecoration: 'underline' }}><strong>Address</strong></p>
                    <p style={{ margin: 0 }}>Shippop Company Limited (Head Office)</p>
                    <p style={{ margin: 0 }}>No.34 C.P.Tower 3 Building, Room No. A04-402, 4th Floor</p>
                    <p style={{ margin: 0 }}>Phayathai road, Thung Phayathai Sub-district, Ratchathewi District, Bangkok 10400</p>
                </>
            ),
            [trans('ค่าภาษีและการเดินพิธีศุลกากร', 'Tax and customs clearance')]: trans(
                <>
                    <p>
                        การส่งสินค้าไปต่างประเทศจะผ่านพิธีการทางศุลกากรที่ประเทศปลายทาง ซึ่งกรมศุลกากรของประเทศปลายทางจะเรียกเก็บค่าภาษีนำเข้า
                        ตามหลักเกณฑ์ที่แตกต่างกันของแต่ละพิกัดสินค้า และมูลค่าของสินค้านั้นๆ หากผู้รับปฏิเสธการรับ ทาง SHIPPOP จะติดต่อผู้ส่งเพื่อยืนยันกระบวนการขั้นต่อไป
                        เช่น นำส่งซ้ำ ส่งกลับ หรือ ทำลาย ค่าใช้จ่ายส่วนเพิ่ม (หากมี) ผู้ส่งจะเป็นผู้รับผิดชอบ
                    </p>
                    <p>
                        ในกรณีทั่วไปผู้รับสินค้ามีหน้าที่จ่ายภาษีนำเข้าที่ประเทศปลายทางหากสินค้ามีมูลค่าเกินที่กำหนดของศุลกากรแต่ละประเทศ โดย Incoterms ที่ SHIPPOP
                        ใช้คือ DDU (Delivery Duty Unpaid) คือ ผู้รับสินค้าปลายทางจะเป็นผู้ดำเนินการชำระภาษีนำเข้าเอง
                        โดยทางบริษัทขนส่งที่เลือกผู้จะเป็นผู้ดำเนินพิธีการนำเข้าให้เท่านั้น
                    </p>
                </>,
                <>
                    <p>
                        Shipments abroad will go through customs clearance in the country of destination which the Customs Department of the destination country will collect import duties
                        according to the different criteria of each product rating and the value of that product. If the recipient declines to receive, SHIPPOP will contact the sender to confirm further processing
                        such as re-sending, returning or destroying, additional costs (if any) will be the sender's responsibility.
                    </p>
                    <p>
                        In general, the consignee is obliged to pay import duty at the country of destination, if the goods exceed the customs limits of each country, provided by Incoterms at SHIPPOP.
                        It is used as DDU (Delivery Duty Unpaid), meaning that the recipient of the product will be responsible for paying the import duty.
                        The Importation formalities will carry out by shipping company only.
                    </p>
                </>
            )
        },
        [trans('การใช้งานระบบ', 'System usage')]: {
            [trans('ขั้นตอนการสมัครเป็นลูกค้ารายสัปดาห์', 'Procedure for signing up as a weekly customer')]: trans(
                <>
                    <p><strong>นิติบุคคล</strong></p>
                    <ul>
                        <li>หนังสือรับรองบริษัท</li>
                        <li>สำเนาบัตรประชาชนของผู้มีอำนาจในหนังสือรับรอง</li>
                        <li>ภพ.20 (ถ้ามี)</li>
                        <li>สำเนาสมุดบัญชีธนาคารย้อนหลังอย่างน้อย 3 เดือน</li>
                        <li>สำเนาหน้าบัญชีธนาคารโดยมีชื่อบัญชีตรงกันกับชื่อบริษัท เท่านั้น</li>
                    </ul>
                    <p><strong>บุคคลธรรมดา</strong></p>
                    <ul>
                        <li>สำเนาบัตรประชาชน</li>
                        <li>สำเนาทะเบียนบ้าน</li>
                        <li>สำเนาสมุดบัญชีธนาคารย้อนหลังอย่างน้อย 3 เดือน</li>
                        <li>สำเนาหน้าบัญชีธนาคารโดยมีชื่อบัญชีตรงกันกับสำเนาบัตรประชาชน</li>
                    </ul>
                    <p>* เอกสารทุกฉบับ รบกวนเซ็นสำเนาถูกต้องและประทับตราบริษัท</p>
                </>,
                <>
                    <p><strong>juristic person</strong></p>
                    <ul>
                        <li>Company Certificate</li>
                        <li>A copy of the identification card of the authorized person in the certificate</li>
                        <li>The certificate of value added tax registration (if any)</li>
                        <li>Copy of bank account book for the past 3 months</li>
                        <li>A copy of the front page of the bank account with the account name matching with the company name only</li>
                    </ul>
                    <p><strong>individual</strong></p>
                    <ul>
                        <li>Copy of identification card</li>
                        <li>Copy of house registration</li>
                        <li>Copy of bank account book for the past 3 months</li>
                        <li>A copy of the front page of the bank account with the same account name as the copy of the identification card</li>
                    </ul>
                    <p>* For all documents, please sign a true copy and seal the company</p>
                </>
            ),
            [trans('การเปลี่ยนแปลงข้อมูลการลงทะเบียน', 'Registration information changing')]: trans(
                <p>
                    หากต้องการเปลี่ยนแปลงข้อมูล จะต้องแนบเอกสารรายละเอียดการเปลี่ยนแปลง และส่งหลักฐาน และข้อมูลการเปลี่ยนแปลงมาทางอีเมล cs_crossborder@shippop.com
                    หรือ Line : @SHIPPOP
                </p>,
                <p>
                    To change information Documents detailing changes must be attached and submit evidence and change information via email cs_crossborder@shippop.com
                    or Line : @SHIPPOP
                </p>
            ),
            [trans('การเปลี่ยนแปลงรหัสผ่าน', 'Password changing')]: trans(
                <>
                    <p>หากต้องการเปลี่ยนแปลงรหัสผ่าน กรุณาแจ้งหลักฐาน และข้อมูลการเปลี่ยนแปลงมาทางอีเมล cs_crossborder@shippop.com หรือ Line : @SHIPPOP</p>
                    <p><strong>ขั้นตอนการเปลี่ยนแปลงรหัสผ่าน</strong></p>
                    <ol>
                        <li>ส่งรายละเอียด</li>
                        <li>รอดำเนินการภายในวันที่รับเรื่อง ไม่เกิน 18.00 น.</li>
                    </ol>
                </>,
                <>
                    <p>To change the password please provide evidence and change information via email cs_crossborder@shippop.com or Line : @SHIPPOP</p>
                    <p><strong>Password change procedure</strong></p>
                    <ol>
                        <li>Submit details</li>
                        <li>Wait for action within the receiving date, no later than 6:00 p.m.</li>
                    </ol>
                </>
            ),
            [trans('สถานะพัสดุ/รายการที่มีปัญหา', 'Parcel status/Defective Items')]:
                <>
                    <img
                        src={`/static/img/faq/status-error-${trans('th', 'en')}.png`}
                        alt="Parcel status/Defective Items"
                        style={{ maxWidth: 750 }}
                    />
                </>
        },
        [trans('ตรวจสอบข้อมูลภาษีแต่ละประเทศปลายทาง', 'De minimis value that is not taxable by country')]: {
            [trans('ตรวจสอบข้อมูลภาษีแต่ละประเทศปลายทาง', 'De minimis value that is not taxable by country')]: 'De minimis'
        }
    }
}

export default getFaqInter
